import type { TResourceCardProps } from "@organisms/ResourceCard/types";

export const allResources: TResourceCardProps[] = [
  {
    image: {
      src: "/static/icons/import.svg",
      alt: "import-icon",
    },
    title: "Reduza seu CAC em até 45% com dados mais precisos",
    description:
      "Campanhas com dados enriquecidos convertem melhor e reduzem o custo por lead. Menos desperdício, mais ROI em mídia paga e e-mail marketing.",
  },
  {
    image: {
      src: "/static/icons/database.svg",
      alt: "database-icon",
    },
    title: "Acelere a produtividade da sua equipe comercial",
    description:
      "Com e-mails, telefones e perfis certos desde o início, seus SDRs focam no que importa: falar com decisores e fechar negócios.",
  },
  {
    image: {
      src: "/static/icons/file-sliders.svg",
      alt: "file-sliders-icon",
    },
    title: "Tenha controle total da origem e performance dos dados",
    description:
      "Chega de planilhas soltas. Com a Data Stone, seus dados são auditáveis, com insights em tempo real e integração via API.",
  },
  {
    image: {
      src: "/static/icons/shield-check.svg",
      alt: "shield-check-icon",
    },
    title: "Gere mais receita com a base que você já tem",
    description:
      "Empresas que usam nossa tecnologia reativam até 30% dos leads descartados. Revalidar dados é retomar oportunidades.",
  },
  {
    image: {
      src: "/static/icons/code-xml.svg",
      alt: "code-xml-icon",
    },
    title: "Escale com segurança jurídica e técnica",
    description:
      "Operamos com padrões como ISO, SOC, PCI e LGPD. Proteja sua empresa contra fraudes e sanções com dados seguros e autorizados.",
  },
  {
    image: {
      src: "/static/icons/cloud-download.svg",
      alt: "cloud-download-icon",
    },
    title: "Pronto para integrar com qualquer ferramenta",
    description:
      "Conecte CRM, ERP, landing pages e automações. Seus dados fluem em tempo real, sempre atualizados — e com mais autonomia para o time.",
  },
];
